import { securedAppApi } from "./securedApi";
const ADD_TEMPLATE = '/Template/Template';
const GET_TEMPLATE = '/Template/Templates';
const ADD_PROJECT = '/Project/Create';
const GET_PROJECT = '/Project/Projects';
const GET_CLIENTS_BY_ID = 'v1/Organizations';
const GET_TEMPLATES_BY_ID = 'Template';
const DELETE_TAMPLAES_BY_ID = 'Template';
const GET_PROJECT_TEAM_MEMBER = 'Project/ProjectTeamMember';
const ADD_EDIT_PROJECT_USER = 'Project/Project';
const GET_ACTIVITY = 'Activity/Activities';
const ADD_EDIT_ACTIVITY = 'Activity/Activity';
const DELETE_ACTIVITY = 'Activity';
const GET_SUB_PROJECT = '/SubProject/SubProjects';
const ADD_SUB_PROJECT = '/SubProject/SubProject';
const GET_PROJECT_ROLES = 'TeamMemberLookUp/ProjectWorkRole';
const DELETE_SUB_PROJECT = 'SubProject';
const ADD_EDIT_PROJECT_ACTIVITY = 'ProjectActivity/ProjectActivity';
const GET_PROJECT_ACTIVITY = 'ProjectActivity/ProjectActivities';
const DELETE_PROJECT_ACTIVITY = 'ProjectActivity';
const GET_PROJECT_BY_ID = 'Project';
const ADD_RESOURCE_ALLOCATION = '/ProjectUser/Projectuser';
const PROJECT_USER = '/ProjectUser';
const GET_PROJECTS_BY_ID = 'Project';
const GET_RESOURCE_ALLOCATION = 'ProjectUser/ProjectUsers';
const UPDATE_PROJECT_USERS = 'ProjectUser/UpdateProjectuser';
const ADD_PROJECT_METHODS = 'Project/ProjectTemplate';
const GET_PROJECT_METHOD_BY_ID = 'Project/ProjectTemplate';
const DELETE_PROJECT = '/Project'
const GET_PROJECT_HIREACHY = '/Project/ProjectHierarchyView';
// const GET_PROJECT_HIREACHY_BY_INDIVIDUAL_ID = '/Project/ProjectHierarchyViewByIndividualId';
const ADD_CHILDREN_PROJECT = '/Project/CreateChild';
const UPDATE_PROJECTHIRERACHY = 'Project/UpdateProjectHirerachyLabels';
const GET_COPY_PROJECS = 'Project/ProjectsByWorkType';
const ADD_COPY_PROJECT_HIREACHY = 'Project/copy-hierarchy';
const GET_USERS_PROJECTS_BY_ID = 'Project/ProjectsByIndividualId';
const GET_PROJECT_USERS_LIST = 'ProjectUser/ProjectUsersList';
const ADD_ASSIGN_PROJECT_ITEM_TO_RESOURCE = 'Project/AddAssignProjectWorkItemToResource';
const UPDATAE_ASSIGN_PROJECT_ITEM_TO_RESOURCE = 'Project/UpdateAssignedProjectWorkItemToResource';
const GET_PROJECTWORKASSIGNMENT_API = 'Project/GetProjectWorkAssignmentByIndividualId';
const GET_PROJECTWORKASSIGNMENT_BYPROJECTID_API = 'Project/GetProjectWorkAssignmentByProjectId';
const GET_PROJECTWORKASSIGNMENT_BYINDIVIDUALIDANDPROJECTID_API = 'Project/GetProjectWorkAssignmentByIndividualIdandProjectId';
const GET_ALL_CUSTOMER_AND_PROJECT = 'Project/GetAllCustomerAndProject';
const ADD_CLONE_PROJECT_HIERARCHY_TREE = 'Project/AddCloneProjectHierarchyTree';
const Add_PROJECT_CLONE = 'Project/clone';
const UPDATE_MULTTI_PROJECTS = 'Project/UpdateMultiProjects'
const GET_PROJECTS_DETAILS_BY_INDIVIDUAL_ID = 'Project/GetProjectDetailsByIndividual';
const DELETE_PROJECT_WORK_ITEM_TO_RESOURCE = 'Project/DeleteProjectWorkItemToResource';
const ASSIGNED_PROJECT_WORK_ITEM_TO_RESOURCE = 'Project/AssignedProjectWorkItemToResource'
const PROJECT_HIERARCHY_BY_CHILD_IDS = 'Project/ProjectHierarchyByChildIds';

const projectApiHandler = securedAppApi.injectEndpoints({
  endpoints: (builder) => ({
    addTemplate: builder.mutation({
      query: (ProfileSignatures) => ({
        url: ADD_TEMPLATE,
        method: 'POST',
        body: ProfileSignatures,
      }),
    }),

    GetTemplates: builder.query({
      query: () =>
        GET_TEMPLATE
    }),

    addProject: builder.mutation({
      query: (addprojects) => ({
        url: ADD_PROJECT,
        method: 'POST',
        body: addprojects,
      }),
    }),

    // GetProject: builder.query({
    //   query: ({ pageNumber, pageSize, searchString, IsActive, organizationIds, customerIds }) =>
    //     GET_PROJECT + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&isActive=${IsActive}&organizationIds=${organizationIds}&customerIds=${customerIds}`
    // }),
    GetProject: builder.query({
      query: ({ pageNumber, pageSize, searchString, IsActive, organizationIds, customerIds }) => {
        // Only include IsActive if it is true or false
        const isActiveParam = IsActive !== undefined && IsActive !== null ? `&isActive=${IsActive}` : '';

        return GET_PROJECT +
          `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&organizationIds=${organizationIds}&customerIds=${customerIds}${isActiveParam}`;
      },
    }),

    GetClientById: builder.query({
      query: ({ ClientId }) =>
        GET_CLIENTS_BY_ID + `/${ClientId}`
    }),

    GetTemplatesById: builder.query({
      query: ({ TemplateId }) =>
        GET_TEMPLATES_BY_ID + `/${TemplateId}`
    }),

    DeleteTemplate: builder.mutation({
      query: (ID: string) => ({
        url: `${DELETE_TAMPLAES_BY_ID}/${ID}`,
        method: 'DELETE',
      }),
    }),

    GetProjectTeamMember: builder.query({
      query: () =>
        GET_PROJECT_TEAM_MEMBER
    }),


    GetProjectById: builder.query({
      query: ({ id }) =>
        `${GET_PROJECT_BY_ID}/${id}`
    }),

    addProjectUser: builder.mutation({
      query: (addProjectUsers) => ({
        url: ADD_EDIT_PROJECT_USER,
        method: 'POST',
        body: addProjectUsers,
      }),
    }),

    GetActivity: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_ACTIVITY + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`,
    }),
    addActivity: builder.mutation({
      query: (addActivitys) => ({
        url: ADD_EDIT_ACTIVITY,
        method: 'POST',
        body: addActivitys,
      }),
    }),

    DeleteActivity: builder.mutation({
      query: (ID: string) => ({
        url: `${DELETE_ACTIVITY}/${ID}`,
        method: 'DELETE',
      }),
    }),

    GetSubProjects: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_SUB_PROJECT + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    DeleteSubProjects: builder.mutation({
      query: (ID: string) => ({
        url: `${DELETE_SUB_PROJECT}/${ID}`,
        method: 'DELETE',
      }),
    }),

    addSubProject: builder.mutation({
      query: (addSubproject) => ({
        url: ADD_SUB_PROJECT,
        method: 'POST',
        body: addSubproject,
      }),
    }),


    GetProjectActivity: builder.query({
      query: ({ pageNumber, pageSize, searchString }) =>
        GET_PROJECT_ACTIVITY + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`,
    }),

    addProjectActivity: builder.mutation({
      query: (addActivitys) => ({
        url: ADD_EDIT_PROJECT_ACTIVITY,
        method: 'POST',
        body: addActivitys,
      }),
    }),

    DeleteProjectActivity: builder.mutation({
      query: (projectId: string) => ({
        url: `${DELETE_PROJECT_ACTIVITY}/${projectId}`,
        method: 'DELETE',
      }),
    }),
    addResourceAllocation: builder.mutation({
      query: (addresource) => ({
        url: ADD_RESOURCE_ALLOCATION,
        method: 'POST',
        body: addresource,
      }),
    }),
    GetProjectsBYId: builder.query({
      query: ({ id }) =>
        GET_PROJECTS_BY_ID + `/${id}`
    }),
    GetProjectUsersAllocation: builder.query({
      query: ({ projectid, searchString, pageNumber, pageSize }) =>
        GET_RESOURCE_ALLOCATION + `?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&ProjectId=${projectid}`
    }),
    GetProjectRoles: builder.query({
      query: () =>
        GET_PROJECT_ROLES
    }),
    UpdateProjectUser: builder.mutation({
      query: (updateproject) => ({
        url: UPDATE_PROJECT_USERS,
        method: 'POST',
        body: updateproject,
      }),
    }),
    AddProjectMethod: builder.mutation({
      query: (addProjectUsers) => ({
        url: ADD_PROJECT_METHODS,
        method: 'POST',
        body: addProjectUsers,
      }),
    }),
    GetProjectMethodbyId: builder.query({
      query: ({ id }) =>
        GET_PROJECT_METHOD_BY_ID + `/${id}`
    }),
    DeleteProject: builder.mutation({
      query: (id: string) => ({
        url: `${DELETE_PROJECT}/${id}`,
        method: 'DELETE',
      }),
    }),
    GetProjectHireachy: builder.query({
      query: ({ projectId, active }) => {
        let url = `${GET_PROJECT_HIREACHY}/${projectId}`;
        if (active !== undefined && active !== null && active !== '') {
          url += `?active=${active}`;
        }
        return url;
      },
    }),

    // GetProjectHierarchyItemsViewByIndividualId: builder.query({
    //   query: ({ projectId, individualId }) => {
    //     let url = `${GET_PROJECT_HIREACHY_BY_INDIVIDUAL_ID}/${projectId}`;
    //     if (individualId !== undefined && individualId !== null && individualId !== '') {
    //       url += `?individualId=${individualId}`;
    //     }
    //     return url;
    //   },
    // }),

    AddChildrenProject: builder.mutation({
      query: (addProjectUsers) => ({
        url: ADD_CHILDREN_PROJECT,
        method: 'POST',
        body: addProjectUsers,
      }),
    }),
    UpdateProjectHirerachy: builder.mutation({
      query: (addProjectUsers) => ({
        url: UPDATE_PROJECTHIRERACHY,
        method: 'POST',
        body: addProjectUsers,
      }),
    }),
    GetProjectsByWorkTypeId: builder.query({
      query: ({ worktypeId }) =>
        GET_COPY_PROJECS + `?ProjectWorkTypeId=${worktypeId}`
    }),
    AddProjectCopy: builder.mutation({
      query: (addProjectUsers) => ({
        url: ADD_COPY_PROJECT_HIREACHY,
        method: 'POST',
        body: addProjectUsers,
      }),
    }),

    GetUserProjectsById: builder.query({
      query: ({ id, pageSize, pageNumber, searchString }) =>
        GET_USERS_PROJECTS_BY_ID + `/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),

    GetProjectUsersList: builder.query({
      query: ({ ProjectId, searchString }) =>
        GET_PROJECT_USERS_LIST + `/${ProjectId}?searchString=${searchString}`
    }),

    AddAssignProjectWorkItemToResource: builder.mutation({
      query: (addActivitys) => ({
        url: ADD_ASSIGN_PROJECT_ITEM_TO_RESOURCE,
        method: 'POST',
        body: addActivitys,
      }),
    }),
    GetProjectWorkAssignmentData: builder.query({
      query: ({ IndividualId, pageNumber, pageSize, searchString }) =>
        GET_PROJECTWORKASSIGNMENT_API + `?individualId=${IndividualId}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    GetProjectWorkAssignmentByProjectIdData: builder.query({
      query: ({ ProjectId, pageNumber, pageSize, searchString }) =>
        GET_PROJECTWORKASSIGNMENT_BYPROJECTID_API + `?projectId=${ProjectId}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    GetProjectWorkAssignmentByIndividualIdandProjectIdData: builder.query({
      query: ({ IndividualId, ProjectId, pageNumber, pageSize, searchString }) =>
        GET_PROJECTWORKASSIGNMENT_BYINDIVIDUALIDANDPROJECTID_API + `?individualId=${IndividualId}&projectId=${ProjectId}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
    }),
    UpdateAssignProjectWorkItemToResource: builder.mutation({
      query: (addActivitys) => ({
        url: UPDATAE_ASSIGN_PROJECT_ITEM_TO_RESOURCE,
        method: 'POST',
        body: addActivitys,
      }),
    }),


    AddCloneProjectHierarchyTree: builder.mutation({
      query: (data) => ({
        url: ADD_CLONE_PROJECT_HIERARCHY_TREE,
        method: 'POST',
        body: data,
      }),
    }),

    clone: builder.mutation({
      query: (data) => ({
        url: Add_PROJECT_CLONE,
        method: 'POST',
        body: data,
      }),
    }),

    GetAllCustomerAndProject: builder.query({
      query: ({ IndividualId, LoggedUserRole, ProjectLeadID, OrganizationIds }) =>
        GET_ALL_CUSTOMER_AND_PROJECT + `?IndividualId=${IndividualId}&LoggedUserRole=${LoggedUserRole}&ProjectLeadID=${ProjectLeadID}&organizationIds=${OrganizationIds}`
    }),

    UpdateMultiProjects: builder.mutation({
      query: (data) => ({
        url: UPDATE_MULTTI_PROJECTS,
        method: 'POST',
        body: data,
      }),
    }),

    DeleteProjectUser: builder.mutation({
      query: (id: string) => ({
        url: `${PROJECT_USER}/${id}`,
        method: 'DELETE',
      }),
    }),

    GetSubProjectsByIndividualId: builder.query({
      query: ({ individualId, fromDate, toDate, levelNumber, isTimeSheet }) =>
        `${GET_PROJECTS_DETAILS_BY_INDIVIDUAL_ID}?individualId=${individualId}&fromDate=${fromDate}&toDate=${toDate}&levelNumber=${levelNumber}${isTimeSheet !== undefined && isTimeSheet !== null ? `&isTimeSheet=${isTimeSheet}` : ''}`,
    }),

    deleteProjectWorkItemToResource: builder.mutation({
      query: (ID: string) => ({
        url: `${DELETE_PROJECT_WORK_ITEM_TO_RESOURCE}/${ID}`,
        method: 'DELETE',
      }),
    }),

    GetAssignedProjectWorkItemToResourceById: builder.query({
      query: ({ id, searchTerm, pageNumber, pageSize }) => ({
        url: `${ASSIGNED_PROJECT_WORK_ITEM_TO_RESOURCE}/${id}`,
        params: {
          searchTerm: searchTerm || '',
          pageNumber,
          pageSize,
        },
      }),
    }),


    GetProjectHierarchyByChildIds: builder.query({
      query: ({ projectId, ids, active }) => {
        const query = active === null || active === undefined
          ? ''
          : `?active=${active}`;

        return {
          url: `${PROJECT_HIERARCHY_BY_CHILD_IDS}/${projectId}${query}`,
          method: 'POST',
          body: ids,
        };
      },
    }),


  }),




});
export const { useAddTemplateMutation, useGetTemplatesQuery, useAddProjectMutation, useGetProjectQuery, useGetClientByIdQuery, useGetTemplatesByIdQuery,
  useDeleteTemplateMutation, useGetProjectTeamMemberQuery, useAddProjectUserMutation, useGetActivityQuery, useAddActivityMutation, useDeleteActivityMutation,
  useGetSubProjectsQuery, useGetProjectRolesQuery, useAddSubProjectMutation, useGetProjectActivityQuery, useAddProjectActivityMutation, useDeleteProjectActivityMutation,
  useDeleteSubProjectsMutation, useGetProjectByIdQuery, useAddResourceAllocationMutation, useGetProjectsBYIdQuery, useGetProjectUsersAllocationQuery,
  useUpdateProjectUserMutation, useAddProjectMethodMutation, useGetProjectMethodbyIdQuery, useDeleteProjectMutation, useGetProjectHireachyQuery,
  useAddChildrenProjectMutation, useUpdateProjectHirerachyMutation, useGetProjectsByWorkTypeIdQuery, useAddProjectCopyMutation, useGetUserProjectsByIdQuery,
  useGetProjectUsersListQuery, useAddAssignProjectWorkItemToResourceMutation, useUpdateAssignProjectWorkItemToResourceMutation, useGetProjectWorkAssignmentDataQuery,
  useGetProjectWorkAssignmentByProjectIdDataQuery, useGetProjectWorkAssignmentByIndividualIdandProjectIdDataQuery, useGetAllCustomerAndProjectQuery,
  useAddCloneProjectHierarchyTreeMutation, useCloneMutation, useUpdateMultiProjectsMutation, useDeleteProjectUserMutation, useGetSubProjectsByIndividualIdQuery,
  useDeleteProjectWorkItemToResourceMutation, useGetAssignedProjectWorkItemToResourceByIdQuery,
  useGetProjectHierarchyByChildIdsQuery,

} = projectApiHandler;
export default projectApiHandler.reducer;
